"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRichTextContent;

var _react = require("react");

var _useBunnyFonts = _interopRequireDefault(require("./useBunnyFonts"));

var _html = require("./html");

var _fonts = require("./fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Processes raw rich-text content for display on a page.
 *
 * - Sanitization
 * - Proper formatting of link hrefs
 * - Replacing dynamic field values
 * - Detecting and loading custom fonts
 *
 * @param {string} content Raw HTML.
 * @param {window} dom Custom DOM instance, to use with i.e. SSR
 */
function useRichTextContent(content) {
  var dom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var preparedContent = (0, _html.sanitize)(content, dom);
  preparedContent = (0, _html.ensureValidLinks)(preparedContent);
  var fontsToLoad = (0, _react.useMemo)(() => (0, _fonts.getFontsFromContent)(content), [content]);
  (0, _useBunnyFonts.default)(fontsToLoad);
  return preparedContent;
}